<template>
    <div class='convention-catalogue clause'>
        <div v-for='(abstraction, aindex) in convention' :key='`abstraction-${aindex}`'>
            <h4>{{abstraction.title}}</h4>
            <ul class='clause-list' v-if='abstraction.subjects'>
                <li v-for='(subject, sindex) in abstraction.subjects' :key='`subject-${sindex}`'>
                    {{aindex + 1}}.{{sindex + 1}}
                    {{subject.name}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['convention']
    }
</script>

